import actionTypes from "../../common/actionTypes";
import { DATABASE_STATUTES } from "../../common/constants";

const subscriptionReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUBSCRIPTION_PLANS:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADING,
        error: null,
      };

    case actionTypes.FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      return {
        ...state,
        plans: action.payload.plans,
        status: DATABASE_STATUTES.LOADED,
        error: null,
      };

    case actionTypes.FETCH_SUBSCRIPTION_PLANS_FAILURE:
      return {
        ...state,
        status: DATABASE_STATUTES.ERROR,
        error: action.error,
      };

    default:
      return state;
  }
};

export { subscriptionReducer };
